import * as React from 'react';
import { connect } from 'react-redux';
import { navigateTo } from '../../../actions/navigationActions';
import { redirectToUrl } from '../../../actions/sspActions';
import { DASHBOARD, PAYMENT_INITIALIZE } from '../../../routes/routes';
import './Payment.css';

class PaymentFailure extends React.Component<any, any> {
    constructor(props) {
        super(props);

        this.state = {
            reference: ""
        };

        this.handleTryAgain = this.handleTryAgain.bind(this);
        this.handleBackHome = this.handleBackHome.bind(this);
    }

    componentDidMount() {
        let reference = this.props.match.params.reference;
        this.setState({ reference });
    }

    handleTryAgain() {
        let url = PAYMENT_INITIALIZE.replace(":reference", this.state.reference);
        this.props.dispatchAction(navigateTo(url));
    }

    handleBackHome() {
        if (this.props.ssp.paymentPortalOnly) {
            this.props.dispatchAction(redirectToUrl(this.props.ssp.portalRedirectUrl));
        } else {
            this.props.dispatchAction(navigateTo(DASHBOARD));
        }
    }

    public render() {
        return (
            <div id="PaymentContainer" className="pt-lg-5 p-lg-0 logged-out">
                <div className="notice-container red">
                    <div className="notice-container-content row">
                        <div className="col-md-6 offset-md-3 text-center">
                            <div>
                                <img src="./images/payment/payment-failed-icon.svg" alt="Failed" />
                            </div>
                            <div className="notice-text mt-4">
                                Your payment was unsuccessful
                            </div>
                            <div className="row">
                                <div className="col-md-6 pt-4">
                                    <button onClick={this.handleTryAgain} className="btn btn-outline-white btn-responsive pull-right btn-lg">Try again</button>
                                </div>
                                <div className="col-md-6 pt-4">
                                    <button onClick={this.handleBackHome} className="btn btn-outline-white btn-responsive pull-left btn-lg">Leave page</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        ssp: state.ssp,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaymentFailure);